const initialState = { activeError: null };

export default initialState;
